<ohp-title-announcer [announcement]="accessibilityTitle"></ohp-title-announcer>
<div class="hero-section"
     [ngStyle]="hideConsumerBackgroundImage ? '' : backgroundStyle"
     [ngClass]="{
                    'hero-section--padded': (appsInHero || hideConsumerBackgroundImage) && !(bottomTrayEnabled && onAppGalleryPage) && !onSearchPage && !onCreatePage,
                    'hero-section__2dot0--padded': onCreatePage || (onHomePageOrPwa && appBarEnabled),
                    'hero-section__homepage--padded': onHomePageOrPwa && !leftNavReact,
                    'hero-section-mobile--padded': bottomTrayEnabled
                }">
    <div  *ngIf="announcementMarkup !== undefined"
          class="hero-announcementMarkup  ms-fcl-ns"
          [ngClass]="{ 'width-restrictor width-restrictor--responsive' : !noGutter, 'width-restrictor--no-gutter' : noGutter }"
        [innerHtml]="announcementMarkup" #heroAnnouncement></div>
    <div *ngIf="!appsInHero && !hideConsumerBackgroundImage"
        class="hero-title-gradient"
        [ngStyle]="heroTitleGradient"></div>
    <div *ngIf="fullBleedThemingEnabled"
         class="hero-background--full-bleed"
         [ngStyle]="bleedBackgroundStyle">
            <div *ngIf="hasSideImages" class="hero-background__image hero-background__image--left" [ngStyle]="heroLeftImageStyle"></div>
            <div class="hero-background__image"
                 [ngClass]="{
                                'hero-background__image--pattern' : isPatternImage,
                                'hero-background__image--center' : !isPatternImage
                            }"
                 [ngStyle]="heroImageStyle"></div>
            <div *ngIf="hasSideImages" class="hero-background__image hero-background__image--right" [ngStyle]="heroRightImageStyle"></div>
    </div>
    <div *ngIf="!appsInHero && !hideConsumerBackgroundImage"
         class="hero-image-container__overlay"
         [ngClass]="{'hero-image-container__overlay--consumer': isConsumer, 'hero-image-container__overlay--consumer--fluent': isConsumer && fluentRefresh}">
        <div class="hero-content--flex"
             [ngClass]="{
                            'width-restrictor width-restrictor--responsive' : !noGutter,
                            'width-restrictor--no-gutter' : noGutter,
                            'hero-content--end-aligned': fluentRefresh
                        }">
            <h1 class="ms-fontWeight-light welcome__title--consumer"
                [ngClass]="{'welcome__title--fluent': fluentRefresh}">
                {{ heroTitle }}
            </h1>
            <div *ngIf="isConsumer"
                 class="hero__buttons-container hero-button-section--consumer"
                 [ngClass]="{'hero-button-section--consumer--fluent': fluentRefresh}">
                   <a *ngIf="isPaidConsumer"
                   id="my-account-link"
                   class="widget-attribution__link my-account__link_new my-account__link_color my-account__link_new_hover_text_decoration my-account__link_margin"
                   [ngStyle]="{ 'color': fullBleedFontColor }"
                   [href]="myAccountUrl"
                   [attr.aria-label]="myAccountLinkText"
                   ohpDefaultLinkTarget>
                    <ohp-icon-font *ngIf="isPaidConsumer"
                                   iconFontName="Diamond"
                                   cssClass="diamond-web"></ohp-icon-font>
                    <span>{{ myAccountLinkText }}</span>
                    <ohp-icon-font iconFontName="ArrowRight"
                                   size="14"
                                   cssClass="link-arrow"></ohp-icon-font>
                </a>
                <ng-container *ngIf="showInstall"
                              ohpLazyView
                              ngModulePath="install#InstallModule"
                              [inputs]="{
                                            componentArea: componentArea,
                                            showInstallButton: showInstallButton,
                                            appFilter: 'Office'
                                        }">
                </ng-container>
            </div>
        </div>
    </div>
    <div [ngClass]="{
                        'width-restrictor' : !noGutter,
                        'width-restrictor--responsive': (!noGutter && heroTitle),
                        'width-restrictor--no-gutter': noGutter,
                        'breadcrumb-width-restrictor': !heroTitle,
                        'breadcrumb-width-restrictor-fallback': !isContextualRailEnabled
                    }">
        <div class="hero-container"
             [ngClass]="{
                            'hero-image-container--fluent': !appsInHero && !hideConsumerBackgroundImage,
                            'hero-image-container': !appsInHero && !hideConsumerBackgroundImage
                        }"
            [attr.role]="showAppTilesHeroTitle ? 'region' : undefined"
            [attr.aria-labelledby]="showAppTilesHeroTitle ? 'hero-heading' : undefined">
            <div class="hero-content--flex" *ngIf="showAppTilesHeroTitle"
                 [ngClass]="{ 'hero-content--centered': onTemplatesPage && !fluentRefresh,
                              'hero-content--small': onHomePageOrPwa,
                              'hero-content': !isSearchSiteScoped && !fluentRefresh,
                              'hero-content--aligned': fluentRefresh,
                              'hero-content--suggested-actions': suggestedActions }">
                <ohp-back-button *ngIf="showBackButton"
                                 [defaultBackRoute]="defaultBackRoute"
                                 [elementId]="backButtonId"
                                 [backButtonAriaLabel]="backButtonAriaLabel"
                                 [responsive]="onTemplatesPage"
                                 [focusOnLoad]="onAppGalleryPage"></ohp-back-button>
                <h1 *ngIf="heroTitle || showFASTBreadcrumb"
                    id="hero-heading"
                    class="ms-fontWeight-light welcome__title ms-fcl-nd"
                    [ngClass]="{'welcome__title--centered': onTemplatesPage && !fluentRefresh,
                                'welcome__title--small': onHomePageOrPwa && !fluentRefresh,
                                'welcome__title--responsive': !fluentRefresh,
                                'welcome__title--fluent': fluentRefresh }"
                    [ngStyle]="{ 'color': fullBleedFontColor }"
                    (click)="showFASTBreadcrumb && backToSearchPage()">
                    {{ heroTitle }}
                    <ng-container *ngIf="showFASTBreadcrumb"
                        ohpLazyView
                        ngModulePath="bread-crumb#FastBreadcrumbModule">
                    </ng-container>
                </h1>
                <ng-container *ngIf="!onAppGalleryPage">
                    <div *ngIf="showCreateLocation" class="hero__create-location">
                        <ohp-create-location [app]="appContext"></ohp-create-location>
                    </div>
                </ng-container>
                <ng-container *ngIf="showHeroButtons">
                    <div class="section__buttons-container hero__buttons-container">
                        <div *ngIf="onAppGalleryPage && store">
                            <a id="app-gallery-store-link"
                               [attr.data-area]="componentArea"
                               data-referral="OfficeStore"
                               class="generic-button generic-button--fluent generic-button--fluent--primary ms-bgc-tp ms-fcl-w ms-bgc-w-h ms-bgc-w-a ms-fcl-tp-h ms-fcl-tp-a ms-fcl-w-f"
                               rel="noopener"
                               ohpDefaultLinkTarget
                               [href]="store.Url">
                                <b class="generic-button__text">{{ store.Text }}</b>
                            </a>
                        </div>
                        <a *ngIf="isPaidConsumer && !onAppGalleryPage"
                           id="my-account-link"
                           class="widget-attribution__link my-account__link ms-fcl-tda ms-fcl-tda-h ms-fcl-tdr-f ms-fcl-tdr-a"
                           [ngStyle]="{ 'color': fullBleedFontColor }"
                           [href]="myAccountUrl"
                           [attr.aria-label]="myAccountLinkText"
                           ohpDefaultLinkTarget>
                           <ohp-icon-font
                                iconFontName="Diamond"
                                class="diamond-pwa ms-fcl-tda">
                           </ohp-icon-font>
                            <span>{{ myAccountLinkText }}</span>
                            <ohp-icon-font iconFontName="ArrowRight"
                                           size="14"
                                           cssClass="link-arrow"></ohp-icon-font>
                        </a>
                        <div>
                            <ng-container *ngIf="showInstall"
                                          ohpLazyView
                                          ngModulePath="install#InstallModule"
                                          [inputs]="{
                                                        componentArea: componentArea,
                                                        showInstallButton: showInstallButton,
                                                        appFilter: 'Office'
                                                    }">
                            </ng-container>
                        </div>
                    </div>
                </ng-container>
            </div>
            <ohp-app-tiles-list *ngIf="showApps"
                                [fullBleedTheming]="fullBleedThemingEnabled"
                                [fullBleedFontColor]="fullBleedFontColor"
                                [fullBleedBackplateEnabled]="fullBleedBackplateEnabled"
                                [fullBleedBackplateStyle]="fullBleedBackplateStyle"></ohp-app-tiles-list>
        </div>
    </div>
</div>
